import React, { useCallback, useEffect, useState } from 'react';
import { useEmissaoNFE } from '~/pages/EmissaoNFE/EmissaoNFEContext';
import Loja from '~/components/Loja';
import useAuth from '~/hooks/useAuth';
import { InputDate, InputNumber } from '~/components/NovosInputs';
import { CustomButtonNovo } from '~/components/Buttons/CustomButtonNovo';
import { IoIosSearch } from 'react-icons/io';
import { MdOutlineCancel } from 'react-icons/md';
import { FaEraser } from 'react-icons/fa';
import { CustomButtonsContainer, InputsContainer } from './styles';
import { toast } from 'react-toastify';
import { GridPedidoPendente } from './components/GridPedidoPendente';
import { format } from 'date-fns';
import { moneyFormat, strPadZeroL } from '~/utils/functions';
import { GridPedidoItemPendente } from './components/GridPedidoItemPendente';
import { FaCheck } from 'react-icons/fa6';
import { PedidoProps } from '~/pages/PdvOnline/types/context';
import { nanoid } from 'nanoid';
import { BaseModal } from '../BaseModal';
import api from '~/services/api';
import { insertOrUpdate } from '~/utils/masterDetail';

export const ModalImportarPedido: React.FC = () => {
  const [codPessoa, setCodPessoa] = useState<number | null>(null);
  const [fetching, setFetching] = useState(false);
  const [pedidoGrid, setPedidoGrid] = useState<any[]>([]);

  const { user } = useAuth();
  const {
    loja,
    isModalOpen,
    onCloseModal,
    handleChangeOpenModalFunction,
    produtos,
    handlePedidosPendentes,
    handleShowTablePedidosPendentes,
    showTablePedidosPendentes,
    pedidoPendenteSelected,
    handleAddProdutoTable,
    handlePedido,
    foirmImportarPedido,
    itensPedidoPendente,
    handleItensPedidosPendentes,
    handlePedidoPendenteSelected,
    formNFE: { getValues },
    formFinanceiro: { setValue: setValueFinanceiro },
    setCodLoja,
    setParcelasFinanceiro,
    setMasterDetail,
    masterDetail,
    codLoja,
  } = useEmissaoNFE();

  const {
    getValuesImportarPedido,
    setErrorImportarPedido,
    registerImportarPedido,
    setValueImportarPedido,
    controlImportarPedido,
    formStateImportarPedido: { errors },
    clearErrorsImportarPedido,
  } = foirmImportarPedido;

  const openModal = () => {
    return isModalOpen.isOpen && isModalOpen.modal === 'pedidoRegistrado';
  };

  const calcularTotal = useCallback(
    (itemArray: any[], arry: 'pedido' | 'financeiro'): number => {
      if (arry === 'financeiro') {
        return (itemArray || []).reduce((total, item) => {
          return total + (item.val_parcela || 0);
        }, 0);
      }

      return (itemArray || []).reduce((total, item) => {
        return total + (item.val_total_produto || 0);
      }, 0);
    },
    [],
  );

  const getPedidosPendente = async (
    cod_loja: number,
    params: {
      cod_pessoa: number | null;
      dta_de: string;
      dta_ate: string;
      num_pedido: string | number;
    },
  ) => {
    const { data } = await api.get(
      `/emissao-nfe/pedidos-pendentes/${cod_loja}`,
      {
        params,
      },
    );
    return data;
  };

  const onSearch = useCallback(async () => {
    handlePedidosPendentes([]);
    handleItensPedidosPendentes([]);
    if (!loja) {
      toast.warning('Loja deve ser informada');
      return;
    }

    if (
      !getValuesImportarPedido('dta_de') &&
      !getValuesImportarPedido('dta_ate')
    ) {
      setErrorImportarPedido('dta_de', { type: 'required' });
      setErrorImportarPedido('dta_ate', { type: 'required' });
      return;
    }

    if (
      !getValuesImportarPedido('dta_de') ||
      !getValuesImportarPedido('dta_ate')
    ) {
      if (!getValuesImportarPedido('dta_de'))
        setErrorImportarPedido('dta_de', { type: 'required' });
      if (!getValuesImportarPedido('dta_ate'))
        setErrorImportarPedido('dta_ate', { type: 'required' });
      return;
    }

    const payload = {
      cod_pessoa: getValues('busca_parceiro')?.cod_pessoa,
      dta_de: getValuesImportarPedido('dta_de'),
      dta_ate: getValuesImportarPedido('dta_ate'),
      num_pedido: getValuesImportarPedido('num_pedido'),
    };

    setFetching(true);

    const { data } = await getPedidosPendente(loja.cod_loja, payload);

    handlePedidosPendentes(data);
    if (data.length > 0) {
      handleShowTablePedidosPendentes(true, false);

      const itemsGrid = data.map((pedido: any) => ({
        id: pedido.cod_seq_pedido,
        num_pedido: pedido.num_pedido,
        qtd_pedido_item: pedido.qtd_pedido_item,
        nome_pessoa: pedido.nome_pessoa,
        val_pedido: moneyFormat(
          calcularTotal(
            pedido.des_json_pedido_financeiro ?? pedido.des_json_pedido_item,
            pedido.des_json_pedido_financeiro ? 'financeiro' : 'pedido',
          ).toFixed(2),
        ),
        dta_emissao: format(new Date(pedido.dta_emissao), 'dd/MM/yyyy'),
        cod_loja: Number(pedido.cod_loja),
      }));

      setPedidoGrid(itemsGrid);
    } else {
      toast.warning(
        'Nenhum registro encontrado conforme o critério informado.',
      );
    }

    setFetching(false);
  }, [
    calcularTotal,
    codPessoa,
    getValuesImportarPedido,
    handlePedidosPendentes,
    handleShowTablePedidosPendentes,
    loja,
    setErrorImportarPedido,
  ]);

  const onClear = useCallback(() => {
    ['num_pedido', 'dta_de', 'dta_ate'].forEach((name) => {
      setValueImportarPedido(name, '');
      clearErrorsImportarPedido(name);
    });

    setValueImportarPedido('busca_parceiro', { value: '', label: '' });
    clearErrorsImportarPedido('busca_parceiro');

    setCodPessoa(null);
    handlePedidosPendentes([]);
    handleItensPedidosPendentes([]);
    handlePedidoPendenteSelected([]);
    setFetching(false);
    handleShowTablePedidosPendentes(false, false);
  }, [
    clearErrorsImportarPedido,
    handlePedidosPendentes,
    handleShowTablePedidosPendentes,
    setValueImportarPedido,
    user,
  ]);

  const handleCloseModal = useCallback(() => {
    onCloseModal();
    handleChangeOpenModalFunction(true);
    onClear();
  }, [handleChangeOpenModalFunction, onClear, onCloseModal]);

  const onCancel = useCallback(() => {
    handleShowTablePedidosPendentes(false, false);
    handlePedidosPendentes([]);
  }, [handlePedidosPendentes, handleShowTablePedidosPendentes]);

  useEffect(() => {
    const handleCloseModalKeyboard = (ev: KeyboardEvent) => {
      if (openModal() && ev.key === 'Escape') handleCloseModal();
    };

    window.addEventListener('keydown', handleCloseModalKeyboard);
    return () =>
      window.removeEventListener('keydown', handleCloseModalKeyboard);
  }, [handleCloseModal]);

  const financeiroFormatter = (financeiros: any) => {
    const rowsFinanceiro = financeiros?.map((item: any) => {
      const uuid = nanoid();
      item.uuid = uuid;
      item.id = uuid;
      return item;
    });

    return rowsFinanceiro;
  };

  const formatToMonetaryValue = useCallback((input: number | string) => {
    if (typeof input === 'number') return input;

    const cleanedInput = input.replace(/[^0-9.,]/g, '');
    const standardizedInput = cleanedInput.replace(',', '.');
    const withoutLeadingZeros = standardizedInput.replace(/^0+(?!\.)/, '');
    const monetaryValue = parseFloat(withoutLeadingZeros);

    if (Number.isNaN(monetaryValue)) return 0;
    return monetaryValue;
  }, []);

  const setFinanceiroInfo = (lastIndex: any, financeiroItens: any) => {
    const ultimoElemento = pedidoPendenteSelected[lastIndex];

    if (ultimoElemento) {
      setValueFinanceiro('categoria', {
        value: ultimoElemento?.cod_categoria,
        cod_subcategoria: ultimoElemento?.cod_subcategoria,
        label: ultimoElemento?.descricao,
      });
      setValueFinanceiro('conta', {
        value: ultimoElemento?.cod_cc,
        label: ultimoElemento?.des_cc_completa,
      });
    }

    const financeiroAgrupado: any[] = [];

    financeiroItens.forEach((item: any) => {
      const existente = financeiroAgrupado.find(
        (f) =>
          f.cod_finalizadora === item.cod_finalizadora &&
          f.dta_vencimento === item.dta_vencimento,
      );
      if (existente) {
        existente.val_parcela += item.val_parcela;
      } else {
        financeiroAgrupado.push({ ...item });
      }
    });

    financeiroAgrupado.sort((a, b) => a.num_condicao - b.num_condicao);

    const seen = new Set<string>();
    const result: any[] = [];

    financeiroAgrupado.forEach((op) => {
      const key = [
        'cod_condicao',
        'cod_finalizadora',
        'cod_parcela',
        'des_condicao',
        'num_condicao',
      ]
        .map((k) => op[k])
        .join('|');

      if (!seen.has(key)) {
        seen.add(key);
        result.push(op);
      }
    });

    const parcelCorrigida = (res: any[]) =>
      res
        .sort(
          (a, b) =>
            new Date(a.dta_vencimento).getTime() -
            new Date(b.dta_vencimento).getTime(),
        )
        .map((p, index) => {
          return {
            ...p,
            val_parcela: formatToMonetaryValue(p.val_parcela || 0),
            num_registro: index + 1,
          };
        });

    const parcelaCorrigida = parcelCorrigida(result);

    parcelaCorrigida.forEach(async (p) => {
      await insertOrUpdate('financeiro', p, masterDetail, setMasterDetail);
    });

    setParcelasFinanceiro(parcelaCorrigida);
  };

  const itensFormatter = (itens: any, produtosInTable: any) => {
    let produtoTables: any[] = [];

    produtoTables = produtosInTable || [];

    itens.forEach((item: any) => {
      const id = nanoid();
      const {
        cod_gtin,
        cod_produto,
        val_total_produto: val_preco,
        val_desconto,
        qtd_pedido,
        des_produto,
        des_unidade,
      } = item;
      const produtotable = {
        ...item,
        id,
        uuid: id,
        num_item: produtosInTable.length + 1,
        cod_produto,
        des_produto,
        des_unidade_venda: des_unidade,
        qtd_produto: qtd_pedido,
        val_preco: moneyFormat(String(val_preco)),
        val_desconto: moneyFormat(val_desconto.toString()),
        val_total: moneyFormat(val_preco),
        cod_gtin_principal: cod_gtin,
        cod_beneficio_fiscal: strPadZeroL(8, item.cod_beneficio_fiscal),
      };

      const existingIndex = produtoTables.findIndex(
        (p: any) => p.cod_produto === produtotable.cod_produto,
      );

      if (existingIndex !== -1) {
        const existingItem = produtoTables[existingIndex];
        const novaQtd =
          Number(existingItem.qtd_total) + Number(produtotable.qtd_total);
        const novoValor =
          Number(existingItem.val_total_produto) +
          Number(produtotable.val_total_produto);
        produtoTables[existingIndex] = {
          ...existingItem,
          qtd_total_produto: novaQtd,
          val_tabela_liq: novoValor,
          val_total: novoValor,
          qtd_total: novaQtd,
          qtd_saida: novaQtd,
        };
      } else {
        produtoTables.push(produtotable);
      }
    });

    return produtoTables;
  };

  const handleSelecionar = async (): Promise<void> => {
    if (!pedidoPendenteSelected?.length) {
      toast.warning('Nenhum pedido selecionado para importar.');
      return;
    }

    // 1) Deduplicar pedidos (num_pedido|cod_seq_pedido) e manter shape de PedidoProps
    const chaves = new Set<string>();
    const pedidos: PedidoProps[] = pedidoPendenteSelected
      .filter(Boolean)
      .filter((e: any) => e.num_pedido !== null && e.cod_seq_pedido !== null)
      .filter((e: any) => {
        const k = `${e.num_pedido}|${e.cod_seq_pedido}`;
        if (chaves.has(k)) return false;
        chaves.add(k);
        return true;
      })
      .map((e: any) => e as PedidoProps);

    // 2) Financeiro em única passada (flatMap)
    const allRowsFinanceiro = pedidoPendenteSelected.flatMap(
      (e: any) =>
        financeiroFormatter(e?.des_json_pedido_financeiro ?? []) ?? [],
    );

    // Mantém comportamento original (último índice)
    setFinanceiroInfo(pedidoPendenteSelected.length - 1, allRowsFinanceiro);

    // 3) Montar produtoTables de forma imutável
    const baseTables =
      Array.isArray(produtos) && produtos.length ? [...produtos] : [];
    const itensPedido = itensFormatter(itensPedidoPendente, baseTables);
    const produtoTables = baseTables.concat(itensPedido);

    // 4) Atualizações finais
    handleAddProdutoTable(produtoTables);
    handlePedido(pedidos);
    onCloseModal();
    onClear();
    toast.success('Pedido(s) importado(s) com sucesso');
  };

  return (
    <BaseModal
      isOpen={openModal()}
      title="Importar Pedido Pendente"
      onClose={handleCloseModal}
      size="lg"
    >
      <Loja
        onChange={(val: number) => {
          setCodLoja(val);
        }}
        resetLojas={false}
        selectedLoja={codLoja}
        disabled
        isDisabled
      />
      <InputsContainer>
        <InputNumber
          label="Nº Pedido:"
          maxLength={99999999}
          placeholder=""
          name="num_pedido"
          min={1}
          max={99999999}
          register={registerImportarPedido}
          disabled={fetching || showTablePedidosPendentes.pedido}
          isError={!!errors.num_pedido}
        />
        <InputDate
          label="Emissão:"
          placeholder=""
          name="dta_de"
          register={registerImportarPedido}
          control={controlImportarPedido}
          disabled={fetching || showTablePedidosPendentes.pedido}
          isError={!!errors.dta_de}
          onChange={(event: any) => {
            setValueImportarPedido('dta_de', event.target?.value);
            clearErrorsImportarPedido('dta_de');
          }}
        />
        <InputDate
          label=" "
          placeholder=""
          name="dta_ate"
          register={registerImportarPedido}
          control={controlImportarPedido}
          disabled={fetching || showTablePedidosPendentes.pedido}
          isError={!!errors.dta_ate}
          onChange={(event: any) => {
            setValueImportarPedido('dta_ate', event.target?.value);
            clearErrorsImportarPedido('dta_ate');
          }}
        />
        <CustomButtonsContainer style={{ marginTop: '2.3rem' }}>
          <CustomButtonNovo
            width={fetching ? '7.4063rem' : '7.125rem'}
            onClick={async () => {
              await onSearch();
            }}
            label="Pesquisar"
            icon={IoIosSearch}
            disabled={fetching || showTablePedidosPendentes.pedido}
            showLoading={fetching}
          />
          <CustomButtonNovo
            width={fetching ? '7.4063rem' : '7.125rem'}
            disabled={fetching || !showTablePedidosPendentes.pedido}
            onClick={onCancel}
            label="Cancelar"
            icon={MdOutlineCancel}
            variant="cancel"
          />
          <CustomButtonNovo
            width={fetching ? '7.4063rem' : '7.125rem'}
            onClick={onClear}
            disabled={fetching || showTablePedidosPendentes.pedido}
            label="Limpar"
            icon={FaEraser}
            variant="clear"
          />
        </CustomButtonsContainer>
      </InputsContainer>
      {showTablePedidosPendentes.pedido && (
        <section
          style={{ display: 'flex', flexDirection: 'column', gap: '0.625rem' }}
        >
          <GridPedidoPendente pedidoGrid={pedidoGrid} />
          {showTablePedidosPendentes.item && (
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '0.625rem',
              }}
            >
              <GridPedidoItemPendente />
              <div
                style={{
                  display: 'flex',
                  width: '100%',
                  justifyContent: 'flex-end',
                }}
              >
                <CustomButtonNovo
                  onClick={async () => {
                    await handleSelecionar();
                  }}
                  showLoading={false}
                  disabled={!pedidoPendenteSelected?.length}
                  label="Selecionar"
                  icon={FaCheck}
                  variant="confirm"
                />
              </div>
            </div>
          )}
        </section>
      )}
    </BaseModal>
  );
};
